EmailFormV2FlexibleContactChannelsView = require "../common/v2_flexible_contact_channels"

class EmailFormUSV2FlexibleContactChannelsView extends EmailFormV2FlexibleContactChannelsView

  arrangeLayoutOfIcons: (hash, $container)->
    orderedContactChannelElements = []
    if hash.contact_channels?
      for contact_channel in hash.contact_channels
        if contact_channel.primary?.channel
          primaryContactElem = @addAttributesToPrimaryIcon(contact_channel.primary, $container)
          orderedContactChannelElements.push(primaryContactElem)

        if contact_channel.secondary?.channel
          secondaryContactElem = @addBloodHoundTagToIcon(contact_channel.secondary.channel, $container, "secondary")
          orderedContactChannelElements.push(secondaryContactElem)

        if contact_channel.tertiary?.channel
          tertiaryContactElem = @addBloodHoundTagToIcon(contact_channel.tertiary.channel, $container, "tertiary")
          orderedContactChannelElements.push(tertiaryContactElem)

      @renderIcons(orderedContactChannelElements, $container)
    $container

  setOrderInfo: ->
    order = Groupon.Support.currentOrder
    if order
      order.deal?.title || order.merchant?.name

  setIssueInfo: ->
    Groupon.Support.ContentModel.getSearchInputIssue() || Groupon.Support.ContentModel.getSubCategory()?.text

  renderLiveChat: () ->
    if @model.get('liveChatExists')
      @mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getFlexibleLiveChatType()
      })
      if @model.get("primaryChannelIsBoldChat")
        @mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
          startFromSameViewState: true
        })

module.exports = EmailFormUSV2FlexibleContactChannelsView
